export default {
  useDocumentCount: (field, tab) => {
    return true
  },
  getPerPage: (tab) => {
    return 15
  },
  getHead: () => {
    return [
      {name: 'No.', style:{minWidth:'100px', width:'100px'}},
      {name: '시설명', key: 'field_name'},
      {name: '관리방법', key: '관리방법'},
      {name: '종별', key: 'meta.classification'},
      {name: '소관부서', key: '소관부서'},
      {name: '담당주무관', key: '담당주무관'},
      {name: '연락처', key: 'phoneNumber'},
      {name: '식수인원', key: '식수인원_일평균_식수인원'},
      {name: '주소', key: 'address'},
    ]
  },
  getCol: (index, row, func) => {
    try {
      switch (index) {
      // No.
      case 0: return func.no
      case 1: return row.field_name
      case 2: return func.meta.관리방법 || '-'
      case 3: return func.meta.classification || "-"
      case 4: return func.meta.소관부서 || "-"
      case 5: return func.meta.담당주무관 || "-"
      case 6: return func.meta.phoneNumber || "-"
      case 7: return func.meta.식수인원_일평균_식수인원 || "-"
      case 8: return row.address || "-"
      }
    } catch (e) { /*ignore*/ }
    return ''
  },
  loadFieldList (searchData) {
    const params = {}

    params.keyword = searchData.keyword
    if (searchData.bri_type) {
      params.metaKey = 'classification'
      params.metaValue = searchData.bri_type
    }

    return params
  },
}
